export default __webpack_public_path__ + "static/media/learn_german.e654fcff.png";